var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { Messages } from 'primereact/messages';
import * as React from "react";
import { connect } from "react-redux";
import * as RegionFactory from "../../classes/definitions/region/region";
import ApiRequests from "../../classes/http/ApiRequests";
import HttpRequests from "../../classes/http/HttpRequests";
import RegionsList from '../../components/Regions/RegionsList/RegionsList';
import AppRoutes from '../../config/appRoutes';
import RegionsReduxProps from "./RegionsReduxProps";
var Regions = /** @class */ (function (_super) {
    __extends(Regions, _super);
    function Regions() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.messages = null;
        _this.state = {
            data: []
        };
        _this.getAllRegions = function () {
            _this.api.getRegions()
                .then(function (response) {
                var methods = RegionFactory.createRegions(response.data);
                _this.setState({ data: methods });
            })
                .catch(function (error) {
                _this.http.handleError(error, _this.messages, 'Не можахме да заредим методите за доставка.', _this.props.history);
            });
        };
        _this.toNewRegion = function () {
            _this.props.history.push(AppRoutes.region.path);
        };
        // Deleting the item from the state
        _this.deleteItem = function (id) {
            var data = __spreadArrays(_this.state.data);
            var result = data.find(function (item) {
                return item.Id === id;
            });
            var index = data.indexOf(result);
            data.splice(index, 1);
            _this.setState({ data: data });
        };
        return _this;
    }
    Regions.prototype.componentDidMount = function () {
        this.getAllRegions();
    };
    Regions.prototype.render = function () {
        var _this = this;
        var data = this.state.data;
        return (React.createElement("div", { className: "container-fluid" },
            React.createElement("div", { className: "animated fadeIn" },
                React.createElement("h1", { className: "display-3" }, "\u0420\u0435\u0433\u0438\u043E\u043D\u0438"),
                React.createElement("hr", null),
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-md-12" },
                        React.createElement("div", { className: "list-actions" },
                            React.createElement("button", { className: "btn btn-sm btn-primary", onClick: this.toNewRegion, type: "button" },
                                React.createElement("i", { className: "fa fa-dot-circle-o" }),
                                " \u041D\u043E\u0432 \u0440\u0435\u0433\u0438\u043E\u043D")),
                        React.createElement(Messages, { ref: function (el) { _this.messages = el; } }),
                        React.createElement(RegionsList, { gridData: data, messages: this.messages, deleteItem: this.deleteItem }))))));
    };
    return Regions;
}(React.Component));
export default connect(null, RegionsReduxProps.mapDispatchToProps)(Regions);



//////////////////
// WEBPACK FOOTER
// ./src/views/Regions/Regions.tsx
// module id = 425
// module chunks = 0